import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProgressBarComponent } from './progress-bar.component';
export { ProgressBarComponent };

export const MODULE_IMPORTS = [CommonModule];

export const MODULE_DECLARATIONS = [ProgressBarComponent];

@NgModule({
  imports: MODULE_IMPORTS,
  declarations: MODULE_DECLARATIONS,
  exports: [ProgressBarComponent],
})
export class GalaxyProgressBarModule {}
